import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, CircularProgress } from '@mui/material';
import { isMobile } from 'react-device-detect';
const DeletePopUp = ({ modal, title, content, onToggleModal, onDeleteRecords, confirmText, cancelText, cancelColor, confirmColor, isLoading, circularloader }) => {
  return (
    <div className='delete-dialoge-section'>
      <Dialog
        open={modal}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onToggleModal();
          }
        }}
       className="add-lease-dialog"
       aria-labelledby="scroll-dialog-title"
      >
        <DialogTitle id="scroll-dialog-title" className='dialog-header'>
          {title ? title : 'Delete'}
        </DialogTitle>
        <DialogContent dividers={true}>
          <div className="delete-record-modal" style={isMobile ? { width: 'auto' } : { minWidth: '400px' }}>
            <div className="">
              {content}
            </div>
            <div className="actions-cta">
              <Button variant="outlined" size='small' onClick={onToggleModal} color={cancelColor ? cancelColor : 'primary'}>{cancelText ? cancelText : 'Cancel'}</Button>
              <Button variant="contained" size='small' onClick={onDeleteRecords} color={confirmColor ? confirmColor : "error"} >
                {circularloader ? <CircularProgress color='inherit' size={20} /> : (confirmText ? confirmText : 'Delete')}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default DeletePopUp;